export default __webpack_public_path__ + "static/72-83f9256f8ad5e55a544fde0543d91be8.png";